import { FormControl } from '@angular/forms';

export class StringValidator {
  static whitespace(fc: FormControl) {
    if (!fc.value) {
      return null;
    }

    if (fc.value.startsWith(' ') || fc.value.endsWith(' ')) {
      return { whiteSpaceNotAllowed: true };
    }

    return null;
  }

  static whitespaceHtml(fc: FormControl) {
    if (!fc.value) {
      return null;
    }

    if (fc.value.startsWith('&#160;') || fc.value.endsWith('&#160;')) {
      return { whiteSpaceNotAllowed: true };
    }

    return null;
  }

  static allowOnlyLettersOrDigits(fc: FormControl) {
    if (!fc.value) {
      return null;
    }

    var regex = /^[a-zA-ZığüşöçĞÜŞÖÇİ0-9]*$/;

    if (!regex.test(fc.value)) {
      return { alphaNumericStringInvalidPattern: true };
    }
  }

  static allowOnlyLettersOrDigitsOrDots(fc: FormControl) {
    if (!fc.value) {
      return null;
    }

    var regex = /^[a-zA-ZığüşöçĞÜŞÖÇİ.0-9]*$/; 

    if (!regex.test(fc.value)) {
      return { alphaNumericAndDotsStringInvalidPattern: true };
    }
  }

  static allowOnlyLettersOrDigitsWithQuestionMarkAndAt(fc: FormControl) {
    if (!fc.value) {
      return null;
    }

    var regex = /^[a-zA-ZığüşöçĞÜŞÖÇİåäÅÄ\u0600-\u06FF0-9 ?%&@.'\-_/\\]*$/;

    if (!regex.test(fc.value)) {
      return { alphaNumericAndStringQuestionMarkAndAtInvalidPattern: true };
    }
  }

  static allowOnlyLettersDigitsAndBasicSymbols(fc: FormControl) {
    if (!fc.value) {
      return null;
    }

    const regex = /^[a-zA-ZığüşöçĞÜŞÖÇİ0-9 _\-\/]+$/;
    if (!regex.test(fc.value)) {
      return {
        alphaNumericAndBasicSymbolsInvalidPattern: true,
      };
    }

    return null;
  }

  static mustContainAtLeastNLetters(minLetterCount: number) {
    return (fc: FormControl) => {
      if (!fc.value) {
        return null;
      }

      const letters = fc.value.match(/[a-zA-ZığüşöçĞÜŞÖÇİ]/g);
      if (!letters || letters.length < minLetterCount) {
        return {
          minLetterCount: {
            key: 'Validation::MustContainAtLeastNLetters',
            required: minLetterCount,
            actual: letters ? letters.length : 0,
          },
        };
      }

      return null;
    };
  }

  static mustStartAndEndWithLetter(fc: FormControl) {
    if (!fc.value) {
      return null;
    }

    const startsWithLetter = /^[a-zA-ZığüşöçĞÜŞÖÇİ]/.test(fc.value);
    const endsWithLetter = /[a-zA-ZığüşöçĞÜŞÖÇİ]$/.test(fc.value);

    if (!startsWithLetter || !endsWithLetter) {
      return { mustStartAndEndWithLetter: true };
    }

    return null;
  }

  static json(fc: FormControl) {
    if (!fc.value) {
      return null;
    }

    try {
      JSON.parse(fc.value);
    } catch (error) {
      return { notAValidJson: true };
    }

    return null;
  }
}
